var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getConfig, getLocale } from "@jti/fe-common";
import { Rest } from "../services/Rest";
export class SearchApi extends Rest {
    constructor(baseUrl, evoTenant, lang) {
        super(baseUrl);
        this.lang = lang;
        this.name = "SearchApi";
        this.setCommonHeader("X-DES-TENANT", evoTenant);
    }
    static init() {
        const config = getConfig();
        const locale = getLocale();
        return new SearchApi(config.EVO_DOMAIN, config.EVO_TENANT, locale);
    }
    getSearchResults(_a) {
        return __awaiter(this, arguments, void 0, function* ({ queryParam, perPage, page, type, locale, highlight = true, }) {
            const params = Object.assign(Object.assign({ q: queryParam, per_page: String(perPage), lang: locale || this.lang.split("-")[0], page: String(page) }, (type && { type })), { highlight: String(Number(highlight)) });
            const { data, meta } = yield this.request(`/api/search?${new URLSearchParams(params)}`, {}, true);
            return {
                data,
                meta,
            };
        });
    }
}
//# sourceMappingURL=SearchApi.js.map